var map = {
	"./X33-Mall_small.jpg": 905,
	"./all-active.svg": 906,
	"./all.svg": 907,
	"./apple-watch.png": 908,
	"./b-headphone.png": 909,
	"./coin.svg": 910,
	"./delete-btn.svg": 911,
	"./iphone-13.webp": 2292,
	"./iphone-pink.png": 912,
	"./love-active.svg": 913,
	"./love.svg": 914,
	"./mobile-bg.jpg": 915,
	"./mobile-bg.webp": 2293,
	"./price-high-active.svg": 916,
	"./price-high.svg": 917,
	"./price-low-active.svg": 918,
	"./price-low.svg": 919,
	"./rewards-dnp-cn.webp": 2294,
	"./rewards-dnp.webp": 2295,
	"./shopping-cart.svg": 920,
	"./star.svg": 921,
	"./x33mall-banner-cn.jpg": 922,
	"./x33mall-banner-cn.webp": 2296,
	"./x33mall-banner-id.jpg": 923,
	"./x33mall-banner-ms.jpg": 924,
	"./x33mall-banner-ms.webp": 2297,
	"./x33mall-banner.jpg": 925,
	"./x33mall-banner.webp": 2298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 927;